import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import {
  PATIENT_FORM_THEME,
  patientFormDialogPaperSx,
  patientFormPrimaryButtonSx,
} from './patientFormTheme';
import {
  patientTaxIdDuplicateMessage,
  patientTaxIdDuplicateTitle,
  taxIdLabel,
} from '../../utils/taxIdRegional';

export type PatientSaveErrorInfo = {
  title: string;
  message: string;
  focusCpf?: boolean;
};

export function resolvePatientSaveError(err: unknown): PatientSaveErrorInfo {
  const raw =
    (err as any)?.response?.data?.error
    || (err as any)?.message
    || 'Não foi possível salvar o paciente. Tente novamente.';
  const msg = String(raw);
  const code = (err as any)?.response?.data?.code;
  const taxLabel = taxIdLabel().toLowerCase();
  const isCpfDuplicate =
    code === 'PATIENT_CPF_DUPLICATE'
    || new RegExp(`${taxLabel}.*cadastrad|já está cadastrado`, 'i').test(msg);

  if (isCpfDuplicate) {
    return {
      title: patientTaxIdDuplicateTitle(),
      message: patientTaxIdDuplicateMessage(),
      focusCpf: true,
    };
  }

  return {
    title: 'Não foi possível salvar',
    message: msg,
  };
}

type PatientSaveErrorDialogProps = {
  open: boolean;
  error: PatientSaveErrorInfo | null;
  onClose: () => void;
};

const PatientSaveErrorDialog: React.FC<PatientSaveErrorDialogProps> = ({
  open,
  error,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: patientFormDialogPaperSx(false) }}
  >
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 700, color: PATIENT_FORM_THEME.navy }}>
      <ErrorOutlineIcon sx={{ color: '#dc2626' }} />
      {error?.title || 'Erro ao salvar'}
    </DialogTitle>
    <DialogContent>
      <Alert severity="error" sx={{ alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {error?.title}
          </Typography>
          <Typography variant="body2">{error?.message}</Typography>
        </Box>
      </Alert>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} variant="contained" sx={patientFormPrimaryButtonSx}>
        Entendi
      </Button>
    </DialogActions>
  </Dialog>
);

export default PatientSaveErrorDialog;
